export default "__VITE_ASSET__BWfTwUe8__"